// // // MemberDetailsModal.js
// // import React from "react";
// // import Modal from "react-bootstrap/Modal";
// // import Button from "react-bootstrap/Button";
// // import { getFirestore, collection, getDocs } from "firebase/firestore";
// // import { getStorage, ref, getDownloadURL } from "firebase/storage";
// // import "./MemberDetailsModal.css";

// // const db = getFirestore();
// // const storage = getStorage();

// // const fetchImageUrl = async (imageId) => {
// //   const storage = getStorage();
// //   const imageRef = ref(storage, `sevakImages/${imageId}`);
// //   const url = await getDownloadURL(imageRef);
// //   console.log("Image URL:", url);
// //   return url;
// // };

// // const MemberDetailsModal = ({ show, onHide, member }) => {
// //   if (!member) return null;

// //   return (
// //     <Modal show={show} onHide={onHide} centered>
// //       <Modal.Header closeButton>
// //         <Modal.Title>Member Details</Modal.Title>
// //       </Modal.Header>
// //       <Modal.Body>
// //         <div className="text-center mb-3">
// //           <img
// //             src={member.profilePicUrl}
// //             alt={member.sevakName}
// //             style={{
// //               width: "150px",
// //               height: "150px",
// //               borderRadius: "8px",
// //               objectFit: "cover",
// //             }}
// //           />
// //         </div>
// //         {/* <div>
// //           <ul className="list-group">
// //             <li className="list-group-item">
// //               <strong>Name:</strong> {member.sevakName}
// //             </li>
// //             <li className="list-group-item">
// //               <strong>Sur Name:</strong> {member.surName}
// //             </li>
// //             <li className="list-group-item">
// //               <strong>Father/Spouse:</strong> {member.fatherOrSpouseName}
// //             </li>
// //             <li className="list-group-item">
// //               <strong>DOB:</strong> {member.dob}
// //             </li>
// //             <li className="list-group-item">
// //               <strong>Email:</strong> {member.email}
// //             </li>
// //             <li className="list-group-item">
// //               <strong>Gender:</strong> {member.gender}
// //             </li>
// //             <li className="list-group-item">
// //               <strong>Profession:</strong> {member.profession}
// //             </li>
// //             <li className="list-group-item">
// //               <strong>Address:</strong> {member.doorNo}, {member.street},{" "}
// //               {member.city}, {member.district}, {member.state} -{" "}
// //               {member.pincode}
// //             </li>
// //             <li className="list-group-item">
// //               <strong>Nearest TTD Temple:</strong> {member.nearestTtdTemple}
// //             </li>
// //           </ul>
// //         </div> */}
// //         <div className="member-details">
// //           <ul className="list-group">
// //             <li className="list-group-item detail-row">
// //               <span className="label">Name:</span>
// //               <span className="value">{member.sevakName}</span>
// //             </li>
// //             <li className="list-group-item detail-row">
// //               <span className="label">Sur Name:</span>
// //               <span className="value">{member.surName}</span>
// //             </li>
// //             <li className="list-group-item detail-row">
// //               <span className="label">Father/Spouse:</span>
// //               <span className="value">{member.fatherOrSpouseName}</span>
// //             </li>
// //             <li className="list-group-item detail-row">
// //               <span className="label">DOB:</span>
// //               <span className="value">{member.dob}</span>
// //             </li>
// //             <li className="list-group-item detail-row">
// //               <span className="label">Email:</span>
// //               <span className="value">{member.email}</span>
// //             </li>
// //             <li className="list-group-item detail-row">
// //               <span className="label">Gender:</span>
// //               <span className="value">{member.gender}</span>
// //             </li>
// //             <li className="list-group-item detail-row">
// //               <span className="label">Profession:</span>
// //               <span className="value">{member.profession}</span>
// //             </li>
// //             <li className="list-group-item detail-row">
// //               <span className="label">Address:</span>
// //               <span className="value">
// //                 {member.doorNo}, {member.street}, {member.city},{" "}
// //                 {member.district}, {member.state} - {member.pincode}
// //               </span>
// //             </li>
// //             <li className="list-group-item detail-row">
// //               <span className="label">Nearest TTD Temple:</span>
// //               <span className="value">{member.nearestTtdTemple}</span>
// //             </li>
// //           </ul>
// //         </div>
// //       </Modal.Body>
// //       <Modal.Footer>
// //         <Button variant="secondary" onClick={onHide}>
// //           Close
// //         </Button>
// //       </Modal.Footer>
// //     </Modal>
// //   );
// // };

// // export default MemberDetailsModal;
// import React, { useEffect, useState } from "react";
// import Modal from "react-bootstrap/Modal";
// import Button from "react-bootstrap/Button";
// import { getStorage, ref, getDownloadURL } from "firebase/storage";
// import "./MemberDetailsModal.css";

// const fetchImageUrl = async (imageId) => {
//   const storage = getStorage();
//   const imageRef = ref(storage, `sevakImages/${imageId}`);
//   const url = await getDownloadURL(imageRef);
//   return url;
// };

// const MemberDetailsModal = ({ show, onHide, member }) => {
//   const [imageUrl, setImageUrl] = useState("");

//   useEffect(() => {
//     const loadImage = async () => {
//       if (member?.imageId) {
//         try {
//           const url = await fetchImageUrl(member.imageId);
//           setImageUrl(url);
//         } catch (error) {
//           console.error("Failed to load image:", error);
//         }
//       } else if (member?.profilePicUrl) {
//         setImageUrl(member.profilePicUrl);
//       }
//     };

//     if (member) {
//       loadImage();
//     }
//   }, [member]);

//   if (!member) return null;

//   return (
//     <Modal show={show} onHide={onHide} centered>
//       <Modal.Header closeButton>
//         <Modal.Title>Member Details</Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         <div className="text-center mb-3">
//           {imageUrl ? (
//             <img
//               src={member.profilePicUrl}
//               alt={member.sevakName}
//               style={{
//                 width: "150px",
//                 height: "150px",
//                 borderRadius: "8px",
//                 objectFit: "cover",
//               }}
//             />
//           ) : (
//             <p>No image available</p>
//           )}
//         </div>

//         <div className="Member Details-details">
//           <ul className="list-group">
//             <li className="list-group-item detail-row">
//               <span className="label">Name:</span>
//               <span className="value">{member.sevakName}</span>
//             </li>
//             <li className="list-group-item detail-row">
//               <span className="label">Sur Name:</span>
//               <span className="value">{member.surName}</span>
//             </li>
//             <li className="list-group-item detail-row">
//               <span className="label">Father/Spouse:</span>
//               <span className="value">{member.fatherOrSpouseName}</span>
//             </li>
//             <li className="list-group-item detail-row">
//               <span className="label">DOB:</span>
//               <span className="value">{member.dob}</span>
//             </li>
//             <li className="list-group-item detail-row">
//               <span className="label">Email:</span>
//               <span className="value">{member.email}</span>
//             </li>
//             <li className="list-group-item detail-row">
//               <span className="label">Gender:</span>
//               <span className="value">{member.gender}</span>
//             </li>
//             <li className="list-group-item detail-row">
//               <span className="label">Profession:</span>
//               <span className="value">{member.profession}</span>
//             </li>
//             <li className="list-group-item detail-row">
//               <span className="label">Address:</span>
//               <span className="value">
//                 {member.doorNo}, {member.street}, {member.city},{" "}
//                 {member.district}, {member.state} - {member.pincode}
//               </span>
//             </li>
//             {/* <li className="list-group-item detail-row">
//               <span className="label">Nearest TTD Temple:</span>
//               <span className="value">{member.nearestTtdTemple}</span>
//             </li> */}
//           </ul>
//         </div>
//       </Modal.Body>
//       <Modal.Footer>
//         <Button variant="secondary" onClick={onHide}>
//           Close
//         </Button>
//       </Modal.Footer>
//     </Modal>
//   );
// };

// export default MemberDetailsModal;

// MemberDetailsModal.js
import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import "./MemberDetailsModal.css";

const MemberDetailsModal = ({ show, onHide, member }) => {
  const [imageUrl, setImageUrl] = useState("");

  useEffect(() => {
    // Prefer Base64 image saved in Firestore; fallback to any existing URL
    if (member) {
      if (member.profilePicBase64) {
        setImageUrl(member.profilePicBase64); // data:image/*;base64,....
      } else if (member.profilePicUrl) {
        setImageUrl(member.profilePicUrl); // fallback if old data
      } else {
        setImageUrl("");
      }
    }
  }, [member]);

  if (!member) return null;

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Member Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="text-center mb-3">
          {imageUrl ? (
            <img
              src={imageUrl}
              alt={member.sevakName}
              style={{
                width: "150px",
                height: "150px",
                borderRadius: "8px",
                objectFit: "cover",
              }}
            />
          ) : (
            <p>No image available</p>
          )}
        </div>

        <div className="Member Details-details">
          <ul className="list-group">
            <li className="list-group-item detail-row">
              <span className="label">Name:</span>
              <span className="value">{member.sevakName}</span>
            </li>
            <li className="list-group-item detail-row">
              <span className="label">Sur Name:</span>
              <span className="value">{member.surName}</span>
            </li>
            <li className="list-group-item detail-row">
              <span className="label">Father/Spouse:</span>
              <span className="value">{member.fatherOrSpouseName}</span>
            </li>
            <li className="list-group-item detail-row">
              <span className="label">DOB:</span>
              <span className="value">{member.dob}</span>
            </li>
            <li className="list-group-item detail-row">
              <span className="label">Email:</span>
              <span className="value">{member.email}</span>
            </li>
            <li className="list-group-item detail-row">
              <span className="label">Gender:</span>
              <span className="value">{member.gender}</span>
            </li>
            <li className="list-group-item detail-row">
              <span className="label">Profession:</span>
              <span className="value">{member.profession}</span>
            </li>
            <li className="list-group-item detail-row">
              <span className="label">Address:</span>
              <span className="value">
                {member.doorNo}, {member.street}, {member.city},{" "}
                {member.district}, {member.state} - {member.pincode}
              </span>
            </li>
            {/* <li className="list-group-item detail-row">
              <span className="label">Nearest TTD Temple:</span>
              <span className="value">{member.nearestTtdTemple}</span>
            </li> */}
          </ul>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MemberDetailsModal;